import { CompactRecentMatches } from "components/Matches/Compact/CompactRecentMatches";
import { TournamentsList } from "components/Tournaments/TournamentsList";
import { Column, GrowColumn } from "pages/styles";
import { COMPACT_COL_WIDTH } from "theme";
import {
  useMultiSubTourFilter,
  useTourFilter,
  useYearFilter,
} from "model/Filter/TournamentFilters";
import { TournamentFilters } from "components/FilterPanels/TournamentsFilters";
import { selectTournamentIdsFromFilters } from "selectors/Tournament";
import { Panel } from "components/Panel/Panel";
import { MultiColumnPage } from "pages/PageTemplates";
import { selectTourIdsFromFilters } from "selectors/Tour";
import { useAppSelector } from "app/hooks";

export const TournamentsPage = () => {
  const yearFilter = useYearFilter(true);
  const selectedYear = yearFilter.selectedValue;
  const tourFilter = useTourFilter(selectedYear, undefined, true, true);
  const selectedTour =
    tourFilter.selectedValue !== "All" ? tourFilter.selectedValue : undefined;
  const subTourFilter = useMultiSubTourFilter(selectedTour);
  const selectedSubTours =
    subTourFilter.options.length > 0 ? subTourFilter.selectedValues : undefined;

  const tournamentIds = useAppSelector((state) =>
    selectTournamentIdsFromFilters(
      state,
      selectedYear,
      selectedTour,
      selectedSubTours,
      undefined,
      true
    )
  );

  const tourIds = useAppSelector((state) =>
    selectTourIdsFromFilters(state, selectedYear, selectedTour)
  );

  return (
    <MultiColumnPage>
      <GrowColumn>
        <TournamentFilters
          yearFilter={yearFilter}
          tourFilter={tourFilter}
          subTourFilter={subTourFilter}
        />
        <TournamentsList tournamentIds={tournamentIds} tourIds={tourIds} />
      </GrowColumn>
      <Column
        style={{ minWidth: COMPACT_COL_WIDTH, maxWidth: COMPACT_COL_WIDTH }}
        hideUnderWidth={1100}
      >
        <Panel header="Recent Matches">
          <CompactRecentMatches amount={8} />
        </Panel>
      </Column>
    </MultiColumnPage>
  );
};
